'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Label = function Label(_ref) {
  var children = _ref.children,
      classNames = _ref.classNames,
      id = _ref.id,
      inputId = _ref.inputId,
      required = _ref.required;
  return _react2.default.createElement(
    'label',
    { className: 'c11n-label ' + classNames.root, id: id, htmlFor: inputId },
    children,
    required && _react2.default.createElement(
      'span',
      { className: classNames.required, title: 'Required field' },
      '*'
    )
  );
};

Label.propTypes = {
  /**
   * The label
   */
  children: _propTypes2.default.any,

  /**
   * The id of the label
   */
  id: _propTypes2.default.string,

  /**
   * The id of the related input
   */
  inputId: _propTypes2.default.string,

  /**
   * Whether the field is required
   */
  required: _propTypes2.default.bool
};

Label.defaultProps = {};

exports.default = (0, _withStyles2.default)(_styles2.default)(Label);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/label/index.js
// module id = 118
// module chunks = 0